export class ResultTask {
    constructor(mode, displayText, url, payload, active, status, date) {
        this.mode = mode;
        this.displayText = displayText;
        this.url = url;
        this.payload = payload;
        this.active = active;
        this.status = status;
        this.date = date;
    }
    clone() {
        return new ResultTask(this.mode, this.displayText, this.url, Object.assign({}, this.payload), this.active, this.status, this.date);
    }
}
